import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';

/**
 * Monitor container scroll state, provide left and right scroll indicators
 * @param container - scroll container
 * @returns scroll state and update function
 */
export default function useScrollFade(container) {
  const $ = _c(10);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  let t0;
  if ($[0] !== container) {
    t0 = () => {
      if (!container) {
        return;
      }
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = container;
      setCanScrollLeft(scrollLeft > 0);
      const remainingRight = scrollWidth - scrollLeft - clientWidth;
      setCanScrollRight(remainingRight > 1);
    };
    $[0] = container;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const update = t0;
  let t1;
  let t2;
  if ($[2] !== container || $[3] !== update) {
    t1 = () => {
      if (!container) {
        return;
      }
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(container);
      container.addEventListener("scroll", update);
      container.addEventListener("touchmove", update);
      requestAnimationFrame(update);
      return () => {
        container.removeEventListener("scroll", update);
        container.removeEventListener("touchmove", update);
        resizeObserver.disconnect();
      };
    };
    t2 = [update, container];
    $[2] = container;
    $[3] = update;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== canScrollLeft || $[7] !== canScrollRight || $[8] !== update) {
    t3 = {
      canScrollLeft,
      canScrollRight,
      updateScrollFade: update
    };
    $[6] = canScrollLeft;
    $[7] = canScrollRight;
    $[8] = update;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}